import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '@config/axios/axios.config';
import { paths } from '@common/types';

interface IPayersShortQueryProps {
  search?: string;
  type?:
    'commercial' | 'medicaid' | 'medicare' | 'bcbs' | 'champus' | 'workerscomp';
}

const payersNameListRequest = async (query: IPayersShortQueryProps) => {
  const response = axiosInstance.get<
    paths[`/insurance/payers`]['get']['responses']['200']['content']['application/json']
  >(`/insurance/payers`, {
    params: query,
  });
  const data = (await response).data;
  return data;
};

export const usePayersNameListQuery = (query: IPayersShortQueryProps) => {
  const folderQuery = useQuery({
    queryKey: ['payersNameList', query.search, query.type],
    enabled: !!(query.search && query.search.length > 1),
    queryFn: () => payersNameListRequest(query),
  });

  return folderQuery;
};

interface IICD10ListQueryProps {
  search?: string;
}

const ICD10ListRequest = async ({ search }: IICD10ListQueryProps) => {
  const response = axiosInstance.get<
    paths[`/insurance/codes`]['get']['responses']['200']['content']['application/json']
  >(`/insurance/codes`, { params: { search } });
  const data = (await response).data;
  return data;
};

export const useICD10ListQuery = ({ search }: IICD10ListQueryProps) => {
  const orgQuery = useQuery({
    queryKey: ['icd10List', search],
    queryFn: () => ICD10ListRequest({ search }),
  });

  return orgQuery;
};
